module.exports = __webpack_public_path__ + "static/img/logo-small.1f0eff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-small.png
// module id = 429
// module chunks = 2